module.exports = __webpack_public_path__ + "static/media/enabout.eb43e8ec.png";